<template>
  <full-container>
    <div slot="header">
      <el-input v-model="queryParams.keyWord" placeholder="输入关键字搜索" clearable @change="onSearch()">
        <template slot="append">
          <el-button class="el-icon-search" @click="onSearch()" />
        </template>
      </el-input>
    </div>
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%" size="mini">
      <el-table-column prop="Name" label="库存编码" width="120">
        <template slot-scope="{ row }">
          <span class="text-sm text-info">
            {{ $utils.meta.format('branch', row.Stock) }}
            {{ row.Code }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="商品名称"/>
      <el-table-column width="100">
        <template slot-scope="{ row }">
          <label v-if="row.Price != 0" class="text-price text-danger">{{ row.Price }}/{{ row.Unit }}</label>
          <label v-else class="text-info">电询</label>
        </template>
      </el-table-column>
      <el-table-column width="60" align="center">
        <template slot="header" slot-scope="{}">
          <el-badge :value="selected.length" :max="9" :hidden="selected.length == 0">
            <i class="el-icon-shopping-cart-1" />
          </el-badge>
        </template>
        <template slot-scope="{ row }">
          <el-link v-if="!Exists(row)" type="primary" :underline="false" class="el-icon-circle-plus-outline" style="font-size: 20px" @click="onInsert(row)" />
          <el-link v-else type="danger" :underline="false" class="el-icon-remove" style="font-size: 20px" @click="onRemove(row)" />
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="toolbar">
      <el-pagination :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
      <el-button type="primary" @click="onSubmit()">确定选择</el-button>
    </div>
  </full-container>
</template>

<script>
export default {
  props: {
    customer: { type: String },
    stock: { type: String },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      selected: [],
      datalist: {},
      queryParams: {
        index: 1,
        size: 30,
        stock: this.stock,
        customer: this.customer,
        state: true
      },
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    Exists () {
      return (row) => {
        return this.selected.filter(x => x.Id == row.Id).length > 0
      }
    }
  },
  methods: {
    // 分页触发事件
    onSearch (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.mall.goods.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    //加入购物车
    onInsert (row) {
      this.selected.push(row)
    },
    //移除购物车
    onRemove (row) {
      this.selected.splice(this.selected.findIndex(item => item.Id === row.Id), 1)
    },

    //确认返回
    onSubmit () {
      typeof this.callback == "function" && this.callback(this.selected)
      this.$layer.close(this.layerid)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-badge) {
  padding: 5px;
  margin-bottom: -5px;
  font-size: 20px;
  &__content.is-fixed {
    top: 8px;
    right: 18px;
  }
}
.flex {
  display: flex;
  .el-image {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
  }
  .content {
    margin-left: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
